module.exports = __webpack_public_path__ + "img/sidebar-icon.cd3536b0.svg";